// extracted by mini-css-extract-plugin
export default {"titleWrapper":"EditDoctorProfileModule_titleWrapper__UhDYE","inputList":"EditDoctorProfileModule_inputList__Howzn"};